import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
/**
 * Vuex全局状态管理
 * @param options {Array} 用于渲染tabs的数组
 */
const store = new Vuex.Store({
  state: {
    title: '',
    options: [],
    activeIndex: 'index',
    tab_options: [],
    tab_activeIndex: 'Home',
    userInfo: {},
    token: null,
    tab_module: 'index', // 当前模块，用于显示tab导航
    curContextTabId: null,
    tabOptions: [{path: '/managementSystem/analysis', name: 'analysis', title: '统计分析', closable: false}] // tab集合
  },
  mutations: {
    login: (state, data) => {
      localStorage.token = data.token || data.identitytoken
      localStorage.userId = data.userId
      localStorage.userName = data.userName
      localStorage.userAccount = data.userAccount
      localStorage.registerType = data.registerType
      localStorage.sqdw = data.userAddress
      state.token = data.token || data.identitytoken
    },
    logout: state => {
      localStorage.removeItem('token')
      localStorage.removeItem('userId')
      localStorage.removeItem('userName')
      localStorage.removeItem('userAccount')
      localStorage.removeItem('registerType')
      localStorage.removeItem('sqdw')
      state.token = null
    },
    title: (state, data) => {
      state.title = data
    },
    // 设置全局用户信息
    setUserInfo (state, userInfo) {
      this.state.userInfo = userInfo
    },
    // 获取用户id
    getUserId() {
      return localStorage.userId
    },
    // 重置面包屑导航
    reset_breadcrumb (state, data) {
      this.state.options = []
      this.state.options.push(data)
    },
    // 添加面包屑导航
    add_breadcrumb (state, data) {
      this.state.options.push(data)
    },
    // 删除面包屑导航
    delete_breadcrumb (state, route) {
      let index = 0
      for (const option of state.options) {
        if (option.route === route) {
          break
        }
        index++
      }
      this.state.options.splice(index, 1)
    },
    // 设置当前激活的tab
    set_active_index (state, index) {
      this.state.activeIndex = index
    },
    // 设置详情信息
    save_detail_info (state, info) {
      this.state.userInfo = info
    },
    // 添加tabs
    add_tabs (state, data) {
      let flag = false
      this.state.tab_options.forEach(element => {
        if (element.name === data.name) {
          flag = true
        }
      })
      if (!flag) {
        this.state.tab_options.push(data)
      }
    },
    // 删除tabs
    delete_tabs (state, route) {
      let index = 0
      for (const option of state.tab_options) {
        if (option.route === route) {
          break
        }
        index++
      }
      this.state.tab_options.splice(index, 1)
    },
    // 设置当前激活的tab
    set_tab_active_index (state, index) {
      this.state.tab_activeIndex = index
    },
    // 清空tabs
    clean_tabs (state, index) {
      this.state.tab_options = []
    },
    // 设置tab_module
    setTabModule(state, data) {
      this.state.tab_module = data
    },
    // 从网上办事大厅后台管理系统拷贝过来的
    // 添加tab
    addTab (state, data) {
      state.tabOptions.push(data)
    },
    // 删除tab
    closeTab (state, data) {
      const index = state.tabOptions.findIndex(item => item.path === data)
      state.tabOptions.splice(index, 1)
    },
    // 保存当前点击的tab
    saveCurContextTabId (state, data) {
      state.curContextTabId = data
    },
    switchTab (state, data) {
      router.push({
        path: data
      })
    },
    // 关闭所有标签
    closeAllTabs (state, data) {
      // state.tabOptions.splice(1, state.tabOptions.length - 1);
      // router.push({
      //     path: state.tabOptions[0].path
      // });
      state.tabOptions = []
      router.push({
        path: '/login'
      })
    },
    // 关闭其它标签页
    closeOtherTabs(state, type) {
      const path = state.curContextTabId
      const index = state.tabOptions.findIndex(item => item.path === path)
      if (type == 'left') {
        state.tabOptions.splice(index - 1, 1)
      } else if (type == 'right') {
        state.tabOptions.splice(index + 1, 1)
        router.push({
          path
        })
      } else if (type == 'other') {
        state.tabOptions = [state.tabOptions[index]]
        if (path == router.app._route.path) return
        router.push({
          path
        })
      };
    }
  },
  actions: {
  },
  getters: {}
})

export default store
